import { render, staticRenderFns } from "./ImportListTable.vue?vue&type=template&id=4f517f72"
import script from "./ImportListTable.vue?vue&type=script&lang=js"
export * from "./ImportListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports